export enum CLOSE_CHAT_TYPES {
    CLOSE_DEFAULT = "CLOSE_CHAT_DEFAULT",
    CLOSE_SILENTLY = "CLOSE_CHAT_SILENTLY",
}

export interface ICloseChatProps {
    isOpened: boolean;
    onClose: () => void;
    closeChat: (chatId: number, forcibly: boolean, silently?: boolean) => void;
    selectedChatId: number;
}